import React from "react";
import styled from "styled-components";

import Text from "../Text";

import WhitePlayButton from "@images/icons/white-play-button.svg";

import theme from "@theme";

const { font, colors } = theme;

const DescriptivePlayButtonWrapper = styled.div`
	background-color: ${(props) =>
		props.playButtonColor === "Brand Orange"
			? `rgba(${colors.brand.rgb}, .90)`
			: props.playButtonColor === "Turquoise"
			? `rgba(${colors.secondary.rgb}, .90)`
			: props.playButtonColor === "Yellow"
			? `rgba(${colors.tertiary.rgb}, .90)`
			: props.playButtonColor === "Purple"
			? `rgba(${colors.quaternary.rgb}, .90)`
			: `rgba(${colors.brand.rgb}, .90)`};
	display: flex;
	padding: 30px;
	padding: 20px 30px;
	border-radius: 30px;

	img {
		margin-right: 12px;
	}
`;

const DescriptivePlayButtonText = styled.div`
	p {
		color: white;
	}

	.video-title {
		font-family: ${font.bold};
	}
`;

const DescriptivePlayButton = ({ playButtonColor, videoTitle, videoLength }) => {
	return (
		<>
			<img src={WhitePlayButton} />

			<DescriptivePlayButtonText>
				{videoTitle && (
					<Text component="b4" className="video-title">
						{videoTitle}
					</Text>
				)}
				{videoLength && (
					<Text component="b6" className="video-time">
						{videoLength}
					</Text>
				)}
			</DescriptivePlayButtonText>
		</>
	);
};

export default DescriptivePlayButton;
